import React, { useState } from "react";
import { Row, Col, Typography, Space, Button, Popconfirm, Image } from "antd";
import { useHistory } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import { gaEvent } from "analytics/analytics";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import { MdFileDownload } from "react-icons/md";
import { Colors } from "theme";
import { Shimmer } from "components/Shimmer";
import * as GA from "constants/analytics";
import fileDownload from "js-file-download";
import axios from "axios";
import FileCard from "components/FileCard";
import PDF from "..//../assets/images/pdf.svg";
import Excel from "../../assets/images/excel.svg";
import Document from "../../assets/images/document.svg";
import Ppt from "../../assets/images/ppt.svg";
import ImageSVG from "../../assets/images/image.svg";
import File from "../../assets/images/file.svg";

const { Title, Link,Text } = Typography;

const ImageContainer = ({ images = [], setImgLoaded, imgLoaded }) => {
  const [[x, y], setXY] = useState([0, 0]);
  const [[imgWidth, imgHeight], setSize] = useState([0, 0]);
  const [showMagnifier, setShowMagnifier] = useState(false);
  const magnifierHeight = 400;
  const magnifieWidth = 400;
  const zoomLevel = 3;

  const customRenderItem = (item, props) => (
    <item.type {...item.props} {...props} />
  );

  const customRenderThumb = (children) => {
    let image = children.map((item) => {
      // console.log("Item : ", item);
      // const imageId = item.props.children[1].props.children.props.largeImage.src;
      const imageId = item.props.children[1].props.src;
      const fallbackImageId = item.props.children[1].props.fallback;
      return <Image src={imageId} fallback={fallbackImageId} preview={false} />;
    });
    return image;
  };

  if (images.length)
    return (
      <Carousel
        width={"90%"}
        showThumbs={true}
        renderItem={customRenderItem}
        renderThumbs={customRenderThumb}
      >
        {images?.map((item, index) => {
          const MagnifiedSrc = item?.directus_files_id?.location
            ? `${process.env.REACT_APP_CLOUDINARY}/b_rgb:f2f2f2,c_pad,h_1200,q_100,w_1800/${item.directus_files_id?.id}`
            : `${process.env.REACT_APP_DIRECTUS}assets/${item?.directus_files_id?.id}?fit=contain&quality=90`;
          const src = `${process.env.REACT_APP_CLOUDINARY}/b_rgb:f2f2f2,c_pad,h_1200,q_100,w_1800/${item.directus_files_id?.id}`;
          const fallbackUrl = `${process.env.REACT_APP_DIRECTUS}assets/${item?.directus_files_id?.id}?fit=contain&width=1800&height=1200&quality=80`;
          return (
            <div
              key={item.directus_files_id?.id}
              onMouseOver={(e) => {
                // update image size and turn-on magnifier
                const elem = e.currentTarget;
                const { width, height } = elem.getBoundingClientRect();
                setSize([width, height]);
                setShowMagnifier(true);
              }}
              onMouseMove={(e) => {
                // update cursor position
                const elem = e.currentTarget;
                const { top, left } = elem.getBoundingClientRect();

                // calculate cursor position on the image
                const x = e.pageX - left - window.pageXOffset;
                const y = e.pageY - top - window.pageYOffset;
                setXY([x, y]);
              }}
              onMouseLeave={() => {
                // close magnifier
                setShowMagnifier(false);
              }}
            >
              {!imgLoaded ? <Shimmer style={{ height: "70vh" }} /> : null}

              <Image
                src={src}
                fallback={fallbackUrl}
                alt={"something"}
                preview={false}
                onLoad={() => setImgLoaded(true)}
                style={{ display: imgLoaded ? "block" : "none" }}
              />

              <div
                style={{
                  cursor: "zoom-in",
                  position: "absolute",
                  display: showMagnifier && imgLoaded ? "" : "none",
                  // prevent maginier blocks the mousemove event of img
                  // pointerEvents: "none",
                  // set size of magnifier
                  height: `${magnifierHeight}px`,
                  width: `${magnifieWidth}px`,
                  // move element center to cursor pos
                  top: `${y - magnifierHeight / 2}px`,
                  left: `${x - magnifieWidth / 2}px`,
                  opacity: "1", // reduce opacity so you can verify position
                  border: "1px solid lightgray",
                  backgroundImage: `url('${MagnifiedSrc}')`,
                  backgroundRepeat: "no-repeat",
                  overflow: "hidden",

                  //calculate zoomed image size
                  backgroundSize: `${imgWidth * zoomLevel}px ${
                    imgHeight * zoomLevel
                  }px`,

                  //calculete position of zoomed image.
                  backgroundPositionX: `${
                    -x * zoomLevel + magnifieWidth / 2
                  }px`,
                  backgroundPositionY: `${
                    -y * zoomLevel + magnifierHeight / 2
                  }px`,
                }}
              />
            </div>
          );
        })}
      </Carousel>
    );

  return (
    <div>
      <Carousel width={"90%"} showThumbs={false}>
        <div>
          <img
            src="http://placehold.jp/24/0a8f8d/ffffff/500x300.png?text=No Images for this product"
            alt="No Images for this product"
          ></img>
        </div>
      </Carousel>
    </div>
  );
};

const DeleteButton = ({
  id,
  productId,
  handleDelete,
  setDeletePopConfirm,
  deletePopConfirm,
  loading,
}) => {
  return (
    <Popconfirm
      title="Are you sure you want to delete this product?"
      visible={deletePopConfirm}
      onConfirm={() => {
        handleDelete(id);
        gaEvent(
          GA.EVENT.CLICK,
          GA.CATEGORY.MASTER_CATALOGUE,
          GA.DESCRIPTION.CATEGORY_WISE_PRODUCT_DELETE_CONFIRM,
          productId
        );
      }}
      onCancel={() => setDeletePopConfirm(false)}
    >
      <Button
        size="large"
        loading={loading}
        style={{
          width: "100%",
          background: Colors.white,
          color: Colors.danger,
          borderColor: Colors.danger,
        }}
        onClick={() => {
          setDeletePopConfirm(true);
          gaEvent(
            GA.EVENT.CLICK,
            GA.CATEGORY.MASTER_CATALOGUE,
            GA.DESCRIPTION.CATEGORY_WISE_PRODUCT_DELETE_BUTTON,
            productId
          );
        }}
      >
        {loading ? "Deleting..." : "Delete"}
      </Button>
    </Popconfirm>
  );
};

const EditButton = ({ id, productId }) => {
  const history = useHistory();

  return (
    <Button
      size="large"
      style={{
        background: "#363E3D",
        color: "white",
        width: "100%",
        border: 0,
      }}
      onClick={() => {
        history.push(`/edit-product/${id}`);
        gaEvent(
          GA.EVENT.CLICK,
          GA.CATEGORY.MASTER_CATALOGUE,
          GA.DESCRIPTION.CATEGORY_WISE_PRODUCT_EDIT_BUTTON,
          productId
        );
      }}
    >
      Edit details
    </Button>
  );
};

const PriceTitle = ({ data }) => {
  if (!data) return null;

  return (
    <Title
      level={3}
      style={{ fontFamily: "Gilroy", margin: "0.5em 0" }}
      className="product-id"
    >
      {data.value}
    </Title>
  );
};

const InfoContainer = ({ data }) => {
  if (!data) return null;
  return data.map((item, index) => {
    return (
      item?.dtype !== "file" && (
        <Row key={index}  >
          
            <Col  span={8}>
              <Title style={{ fontSize: "16px", margin: 0 }} type="secondary">
                {`${item.name}`}
              </Title>
            </Col>

            <Col  span={15} offset={1}>
              <span
                style={{
                  fontSize: "16px",
                  paddingTop: "4px",
                  //  overflowWrap: "break-word",
                  overflowWrap:'break-word'
                }}
              >
                {
                typeof item?.value === "object" ? item?.value.join(", ") : item?.value
              }
              </span>
            </Col>
          
        </Row>
      )
    );
  });
};

const FileList = ({ data }) => {
  if (!data) return null;

  const handleDownload = (file) => {
    axios
      .get(`${process.env.REACT_APP_DIRECTUS}assets/${file.id}`, {
        responseType: "blob",
      })
      .then((res) => {
        // window.open(res?.data?.ppt_url, "_self");
        fileDownload(res.data, `${file?.name}`);
        // setspinning(false);
        // setFileType("");
      })
      .catch((err) => {
        // setError(true);
        // setspinning(false);
        // setFileType("");
      });
  };

  const showCta = (name) => {
    function getExtension(filename) {
      var parts = filename.split(".");
      return parts[parts.length - 1];
    }
    var ext = getExtension(name);
  };
  const fileType = (name) => {
    function getExtension(filename) {
      var parts = filename.split(".");
      return parts[parts.length - 1];
    }
    var ext = getExtension(name);

    const fileObj = {
      pdf: "pdf",
      png: "image",
      jpg: "image",
      jpeg: "image",
      doc: "document",
      docx: "document",
      xls: "excel",
      xlsx: "excel",
      ppt: "ppt",
      pptx: "ppt",
      txt: "document",
      csv: "excel",
      zip: "file",
      rar: "file",
    };

    const iconObj = {
      image: <img src={ImageSVG} alt="alt" width={48} />,
      pdf: <img src={PDF} alt="alt" width={48} />,
      document: <img src={File} alt="alt" width={48} />,
      excel: <img src={Excel} alt="alt" width={48} />,
      file: <img src={Document} alt="alt" width={48} />,
      ppt: <img src={Ppt} alt="alt" width={48} />,
    };
    return iconObj[fileObj[ext]] || <img src={File} alt="alt" width={48} />;
  };
  return data.map((item, index) => {
    return (
      item?.dtype === "file" && (
        <Row key={index}>
          {/* <Space>
            {item.value && (
              <Row>
                <Col style={{ width: "10em" }}>
                  <Title
                    style={{ fontSize: "16px", margin: 0 }}
                    type="secondary"
                  >
                    {`${item.name}`}
                  </Title>
                </Col>

                <Col>
                  <Title
                    style={{
                      fontSize: "16px",
                      paddingTop: "4px",
                      overflowWrap: "break-word",
                    }}
                  >
                    {`${item.value}`}
                  </Title>
                </Col>
              </Row>
            )}
          </Space> */}

          {item?.composite?.length > 0 && (
            <Col span={24} style={{ marginLeft: 8 }}>
              <Title
                style={{ fontSize: "16px", margin: 0, color: "black" }}
                type="secondary"
              >
                {`${item.name}`}
              </Title>
            </Col>
          )}

          <Col span={24}>
            {item?.dtype === "file" &&
              item?.composite?.length > 0 &&
              item?.composite?.map((file, index) => (
                <FileCard
                  fileName={file?.name}
                  fileIcon={fileType(file?.name)}
                  actionIcon={
                    <MdFileDownload
                      fontSize="24px"
                      color="#B4B7B6"
                      cursor="pointer"
                      onClick={() => handleDownload(file)}
                    />
                  }
                  secondaryAction={
                    file?.name.includes("png") ||
                      file?.name.includes("PNG") ||
                      file?.name.includes("JPG") ||
                      file?.name.includes("JPEG") ||
                      file?.name.includes("pdf") ||
                      file?.name.includes("jpg") ||
                      file?.name.includes("jpeg") ||
                      file?.name.includes("heic") ||
                      file?.name.includes("webp") ? (
                      <Link
                        href={`${process.env.REACT_APP_DIRECTUS}assets/${file.id}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Click here to view
                      </Link>
                    ) : null
                  }
                />
              ))}
          </Col>
        </Row>
      )
    );
  });
};

const SelectProductButton = ({ isSelected, handleProductSelection }) => {
  return (
    <Button
      size="large"
      style={{
        background: isSelected ? "rgb(39,137,119)" : "#1D2624",
        color: "white",
        width: "100%",
        border: 0,
      }}
      onClick={() => {
        handleProductSelection();
      }}
    >
      {isSelected ? "Selected" : " Select this product"}
    </Button>
  );
};

const tansformModalData = (data = {}) => {
  const priceTitle = [];
  const productionDetails = [];
  const others = [];

  data?.attributes?.forEach((item) => {
    if (item.name === "Selling Price" && !item.is_internal) {
      priceTitle.push(item);
    } else if (item.tabname === "production_detail") {
      productionDetails.push(item);
    } else {
      others.push(item);
    }
  });

  const { attributes, ...rest } = data;

  return {
    ...rest,
    priceTitle: priceTitle[0],
    productionDetails,
    others,
  };
};
export {
  SelectProductButton,
  ImageContainer,
  DeleteButton,
  EditButton,
  PriceTitle,
  InfoContainer,
  tansformModalData,
  FileList,
};
